import Class from './program-card';
import './program-card@';

export default Class;